import { Platform } from '../types/platform';
import { PlatformApi } from '../types/platform-api';

export class WebPlatformApi implements PlatformApi {
  platform = Platform.Web;
  isMobile = false;

  initialize(): void {}
}
